import { CountryDto } from "@core/types/common.types";
import { LocaleConfig } from "@ogs-gmbh/ngx-translate";

/**
 * Represents the update-dto of the language of an Employee
 */
export type CustomerLanguageUpdateDto = Pick<CountryDto, "iso2">;
/**
 * Parses a {@link LocaleConfig} to a {@link CustomerLanguageUpdateDto}
 * @param value The Locale-Config to parse
 * @returns The parsed customer-language-update
 */
export function parseToCustomerLanguageUpdateDto (value: LocaleConfig): CustomerLanguageUpdateDto {
  return {
    iso2: value.value
  };
}
